import { PagingInfo } from "@/core/types/contentTypes";
import { useAppSelector } from "@/core/store/reduxHooks";
import useLangSelector from "@/core/dataProviders/hooks/useLangSelector";
import {
  SpecialPostsPagingInfoSelector,
  PostsByAuthorPagingInfoSelector,
  PostsByCategoryPagingInfoSelector,
  PostsBySearchTermPagingInfoSelector,
  PostsByTagPagingInfoSelector,
  LatestPostsPagingInfoSelector,
  PopularPostsPagingInfoSelector,
  PostsByTopicPagingInfoSelector,
  PostsBySpecialPagingInfoSelector,
  PostsByLengthPagingInfoSelector,
  PostsWithGalleryPagingInfoSelector,
} from "@/core/store/posts/PostsSlice";
import getPagingInfo from "@/core/dataProviders/utils/getPagingInfo";
import { useEffect, useState } from "react";
import { TagsBySearchTermPagingInfoSelector, TagsBySignPagingInfoSelector } from "@/core/store/tags/TagsSlice";
import { DataRequestSign } from "@/core/types/dataRequestsTypes";
import { IssuesBySignPagingInfoSelector } from "@/core/store/issues/IssuesSlice";

export function useLatestPostsPagingInfo(sign: { perPage?: number; excludeFeatured?: boolean }): PagingInfo | null {
  const latestPostsPagingInfo = useLangSelector(useAppSelector(LatestPostsPagingInfoSelector));
  const [currentPagingInfo, setCurrentPagingInfo] = useState<PagingInfo | null>(
    getPagingInfo(sign, latestPostsPagingInfo)
  );

  useEffect(() => {
    setCurrentPagingInfo(getPagingInfo(sign, latestPostsPagingInfo));
  }, [latestPostsPagingInfo]);

  return currentPagingInfo;
}

// @TODO try, because currently there is no special content with paging
export function useSpecialPostsPagingInfo(sign: DataRequestSign | null): PagingInfo | null {
  const specialPostsPagingInfo = useLangSelector(useAppSelector(SpecialPostsPagingInfoSelector));
  const [currentPagingInfo, setCurrentPagingInfo] = useState<PagingInfo | null>(
    getPagingInfo(sign ? sign : null, specialPostsPagingInfo)
  );

  useEffect(() => {
    setCurrentPagingInfo(getPagingInfo(sign ? sign : null, specialPostsPagingInfo));
  }, [specialPostsPagingInfo]);

  return currentPagingInfo;
}

export function usePostsByCategoryPagingInfo(sign: { slug: string; perPage?: number } | null): PagingInfo | null {
  const postsByCategoryPagingInfo = useLangSelector(useAppSelector(PostsByCategoryPagingInfoSelector));
  const [currentPagingInfo, setCurrentPagingInfo] = useState<PagingInfo | null>(
    getPagingInfo(sign, postsByCategoryPagingInfo)
  );

  useEffect(() => {
    setCurrentPagingInfo(getPagingInfo(sign, postsByCategoryPagingInfo));
  }, [postsByCategoryPagingInfo]);

  return currentPagingInfo;
}

export function usePostsByTopicPagingInfo(sign: { slug: string; perPage?: number } | null): PagingInfo | null {
  const postsByTopicPagingInfo = useLangSelector(useAppSelector(PostsByTopicPagingInfoSelector));
  const [currentPagingInfo, setCurrentPagingInfo] = useState<PagingInfo | null>(
    getPagingInfo(sign, postsByTopicPagingInfo)
  );

  useEffect(() => {
    setCurrentPagingInfo(getPagingInfo(sign, postsByTopicPagingInfo));
  }, [postsByTopicPagingInfo]);

  return currentPagingInfo;
}

export function usePostsByGenrePagingInfo(sign: { slug: string; perPage?: number } | null): PagingInfo | null {
  const postsByGenrePagingInfo = useLangSelector(useAppSelector(PostsByTopicPagingInfoSelector));
  const [currentPagingInfo, setCurrentPagingInfo] = useState<PagingInfo | null>(
    getPagingInfo(sign, postsByGenrePagingInfo)
  );

  useEffect(() => {
    setCurrentPagingInfo(getPagingInfo(sign, postsByGenrePagingInfo));
  }, [postsByGenrePagingInfo]);

  return currentPagingInfo;
}

export function usePostsBySpecialPagingInfo(
  sign: { slug: string; perPage?: number; audioOnly?: true } | null
): PagingInfo | null {
  const postsBySpecialPagingInfo = useLangSelector(useAppSelector(PostsBySpecialPagingInfoSelector));
  const [currentPagingInfo, setCurrentPagingInfo] = useState<PagingInfo | null>(
    getPagingInfo(sign, postsBySpecialPagingInfo)
  );

  useEffect(() => {
    setCurrentPagingInfo(getPagingInfo(sign, postsBySpecialPagingInfo));
  }, [postsBySpecialPagingInfo]);

  return currentPagingInfo;
}

export function usePostsByLengthPagingInfo(sign: { slug: string; perPage?: number } | null): PagingInfo | null {
  const postsByLengthPagingInfo = useLangSelector(useAppSelector(PostsByLengthPagingInfoSelector));
  const [currentPagingInfo, setCurrentPagingInfo] = useState<PagingInfo | null>(
    getPagingInfo(sign, postsByLengthPagingInfo)
  );

  useEffect(() => {
    setCurrentPagingInfo(getPagingInfo(sign, postsByLengthPagingInfo));
  }, [postsByLengthPagingInfo]);

  return currentPagingInfo;
}

export function usePostsByTagPagingInfo(sign: { slug: string; perPage?: number } | null): PagingInfo | null {
  const postsByTagPagingInfo = useLangSelector(useAppSelector(PostsByTagPagingInfoSelector));
  const [currentPagingInfo, setCurrentPagingInfo] = useState<PagingInfo | null>(
    getPagingInfo(sign, postsByTagPagingInfo)
  );

  useEffect(() => {
    setCurrentPagingInfo(getPagingInfo(sign, postsByTagPagingInfo));
  }, [postsByTagPagingInfo]);

  return currentPagingInfo;
}

export function usePostsByAuthorPagingInfo(sign: { slug: string; perPage?: number } | null): PagingInfo | null {
  const postsByAuthorPagingInfo = useLangSelector(useAppSelector(PostsByAuthorPagingInfoSelector));
  const [currentPagingInfo, setCurrentPagingInfo] = useState<PagingInfo | null>(
    getPagingInfo(sign, postsByAuthorPagingInfo)
  );

  useEffect(() => {
    setCurrentPagingInfo(getPagingInfo(sign, postsByAuthorPagingInfo));
  }, [postsByAuthorPagingInfo]);

  return currentPagingInfo;
}

export function usePostsBySearchTermPagingInfo(sign: { slug: string; perPage?: number } | null): PagingInfo | null {
  const postsBySearchTermPagingInfo = useLangSelector(useAppSelector(PostsBySearchTermPagingInfoSelector));
  const [currentPagingInfo, setCurrentPagingInfo] = useState<PagingInfo | null>(
    getPagingInfo(sign, postsBySearchTermPagingInfo)
  );

  useEffect(() => {
    setCurrentPagingInfo(getPagingInfo(sign, postsBySearchTermPagingInfo));
  }, [postsBySearchTermPagingInfo]);

  return currentPagingInfo;
}

export function useTagsPagingInfo(sign: { perPage?: number }): PagingInfo | null {
  const tagsBySignPagingInfo = useLangSelector(useAppSelector(TagsBySignPagingInfoSelector));
  const [currentPagingInfo, setCurrentPagingInfo] = useState<PagingInfo | null>(
    getPagingInfo(sign, tagsBySignPagingInfo)
  );

  useEffect(() => {
    setCurrentPagingInfo(getPagingInfo(sign, tagsBySignPagingInfo));
  }, [tagsBySignPagingInfo]);

  return currentPagingInfo;
}

export function useTagsBySearchTermPagingInfo(sign: { slug: string; perPage?: number } | null): PagingInfo | null {
  const tagsBySearchTermPagingInfo = useLangSelector(useAppSelector(TagsBySearchTermPagingInfoSelector));
  const [currentPagingInfo, setCurrentPagingInfo] = useState<PagingInfo | null>(
    getPagingInfo(sign, tagsBySearchTermPagingInfo)
  );

  useEffect(() => {
    setCurrentPagingInfo(getPagingInfo(sign, tagsBySearchTermPagingInfo));
  }, [tagsBySearchTermPagingInfo]);

  return currentPagingInfo;
}

export function usePopularPostsPagingInfo(sign: { dayRange: number; perPage?: number }): PagingInfo | null {
  const popularPostsPagingInfo = useLangSelector(useAppSelector(PopularPostsPagingInfoSelector));
  const [currentPagingInfo, setCurrentPagingInfo] = useState<PagingInfo | null>(
    getPagingInfo(sign, popularPostsPagingInfo)
  );

  useEffect(() => {
    setCurrentPagingInfo(getPagingInfo(sign, popularPostsPagingInfo));
  }, [popularPostsPagingInfo]);

  return currentPagingInfo;
}

export function usePopularPostsByCategorySlugPagingInfo(
  sign: { slug: string; dayRange: number; perPage?: number } | null
): PagingInfo | null {
  const popularPostsPagingInfo = useLangSelector(useAppSelector(PopularPostsPagingInfoSelector));
  const [currentPagingInfo, setCurrentPagingInfo] = useState<PagingInfo | null>(
    getPagingInfo(sign ? sign : null, popularPostsPagingInfo)
  );

  useEffect(() => {
    setCurrentPagingInfo(getPagingInfo(sign ? sign : null, popularPostsPagingInfo));
  }, [popularPostsPagingInfo]);

  return currentPagingInfo;
}

export function useAllIssuesPagingInfo(sign: { perPage: number } | null): PagingInfo | null {
  const issuesPagingInfo = useLangSelector(useAppSelector(IssuesBySignPagingInfoSelector));
  const [currentPagingInfo, setCurrentPagingInfo] = useState<PagingInfo | null>(
    getPagingInfo(sign ? sign : null, issuesPagingInfo)
  );

  useEffect(() => {
    setCurrentPagingInfo(getPagingInfo(sign ? sign : null, issuesPagingInfo));
  }, [issuesPagingInfo]);

  return currentPagingInfo;
}

export function usePostsWithGalleryPagingInfo(sign: {
  perPage?: number;
  excludeFeatured?: boolean;
}): PagingInfo | null {
  const postsWithGalleryPagingInfo = useLangSelector(useAppSelector(PostsWithGalleryPagingInfoSelector));
  const [currentPagingInfo, setCurrentPagingInfo] = useState<PagingInfo | null>(
    getPagingInfo(sign, postsWithGalleryPagingInfo)
  );

  useEffect(() => {
    setCurrentPagingInfo(getPagingInfo(sign, postsWithGalleryPagingInfo));
  }, [postsWithGalleryPagingInfo]);

  return currentPagingInfo;
}
